import { CustomTheme } from '@masfront/common-b2c'

import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(({ palette, name, spacing }: CustomTheme) => ({
  personal: {
    backgroundColor: name === 'masmovil' ? palette.grey[700] : palette.primary.dark,
    color: palette.grey[50],
  },
  name: {
    textTransform: 'capitalize',
  },
  pill: {
    backgroundColor: palette.grey[50],
    padding: `${spacing(2)}px ${spacing(2)}px ${spacing(2)}px`,
    borderRadius: `${spacing(1)}px`,
    color: name === 'masmovil' ? palette.grey[700] : palette.primary.dark,
  },
  padding: {
    padding: `0px ${spacing(2)}px`,
  },
  icon: {
    fontSize: `${spacing(4)}px`,
    marginRight: `${spacing(1)}px`,
  },
  greyColor: {
    color: palette.grey[200],
  },
  accordion: {
    background: 'transparent',
    boxShadow: 'none',
    borderBottomColor: palette.grey[50],
    borderBottomWidth: '1px',
    color: palette.grey[50],
    '& .MuiIconButton-label': {
      color: palette.grey[50],
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '50px',
    },
    '& .MuiAccordionSummary-root': {
      padding: '0px',
    },
    '& .MuiAccordionDetails-root': {
      padding: `${spacing(1)}px 0px`,
    },
  },
  summary: {
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: `${spacing(3)}px 0px`,
    },
  },
  title: {
    color: palette.grey[50],
  },
}))

export default useStyles
